import { FILTER_CONTEXT_LABELS, FILTER_CONTEXTS } from "@search/api/constants";
import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class FourBallFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: FILTER_CONTEXT_LABELS[FILTER_CONTEXTS.four_ball],
      name: "fourBall",
      value,
    });
  }
}

export default FourBallFilter;
export { FourBallFilter };
